import { FC, HTMLAttributes } from "react";
import Image from "next/image";

import TButton from "@/components/atoms/buttons/TButton";
import { ITextButton } from "@/components/atoms/buttons/types";

// ----------------------------------------------------------------------------

export type IMenuDownloadBook = {
  heading?: string;
  image?: { src: string; alt?: string };
  button?: ITextButton;
};

export type IMenuDownloadSectionProps = HTMLAttributes<HTMLDivElement> &
  IMenuDownloadBook & {};

const MenuDownloadSection: FC<IMenuDownloadSectionProps> = (props) => {
  const { heading, image, button, className, ...other } = props;

  if (!heading && !image && !button) return;

  return (
    <div className={className} {...other}>
      {(heading || image?.src) && (
        <div className="w-full bg-primary-50 p-8 xl:max-w-[395px] xl:py-10 xl:pl-10 xl:pr-[34px]">
          <div
            className={
              "flex flex-col gap-2 md:flex-row md:items-center xl:gap-5"
            }
          >
            {image?.src && (
              <Image
                src={image.src}
                alt={image.alt ?? ""}
                height={154}
                width={140}
              />
            )}

            {heading && (
              <div className="w-full max-w-[160px]">
                <p className="text-base font-normal text-black-900">
                  {heading}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {button?.text && (
        <TButton
          id={button.id}
          href={button.link}
          variant={button.variant}
          radius={button.radius}
          target={button.target}
          className="mt-7"
        >
          {button.text}
        </TButton>
      )}
    </div>
  );
};

export default MenuDownloadSection;
